import { createFileRoute, redirect } from '@tanstack/react-router';

// Redirect to /home
export const Route = createFileRoute('/')({
    beforeLoad: () => {
        throw redirect({ to: '/home' });
    },
});
